import React from "react";
import TennisDoubleCourt from "./TennisDoubleCourt";
import TennisSingleCourt from "./TennisSingleCourt";
import TennisThreeCourt from "./TennisThreeCourt";
import TennisFourthCourtHorizontol from "./TennisFourthCourtHorizontol";
import TennisFourthCourtVertical from "./TennisFourthCourtVertical";
import TennisFifthCourt from "./TennisFifthCourt";
import TennisSixthCourtHorizontol from "./TennisSixthCourtHorizontol";
import TennisSixthCourtVertical from "./TennisSixthCourtVertical";
import TennisSevenCourt from "./TennisSevenCourt";
import TennisEightHorizontol from "./TennisEightHorizontol";
import TennisEightVertical from "./TennisEightVerticalCourt";

const TennisCourtEstimate = ({ numberOfCourt }) => {
  const renderCourt = (numberOfCourt) => {
    switch (numberOfCourt) {
      case "one-option":
        return <TennisSingleCourt />;
      case "2-option":
        return <TennisDoubleCourt />;
      case "three-option":
        return <TennisThreeCourt />;
      case "four-horizontal-option-2":
        return <TennisFourthCourtHorizontol />;
      case "four-vertical-option":
        return <TennisFourthCourtVertical />;
      case "five-option-2":
        return <TennisFifthCourt />;
      case "six-horizontal-option-2":
        return <TennisSixthCourtHorizontol />;
      case "six-vertical-option-3":
        return <TennisSixthCourtVertical />;
      case "seven-option-2":
        return <TennisSevenCourt />;
      case "eight-horizontal-option-2":
        return <TennisEightHorizontol />;
      case "eight-vertical-option-2":
        return <TennisEightVertical />;
      default:
        return <TennisSingleCourt />;
    }
  };

  return <>{renderCourt(numberOfCourt)}</>;
};

export default TennisCourtEstimate;
